import React from "react";
import AkasLogo from "../AkasLogo";
import { recoverFromAssetLoadError } from "../../utils/helpers/runtimeRecovery";
import { reportRuntimeError } from "../../utils/helpers/runtimeErrorReporter";

class AppErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    if (recoverFromAssetLoadError(error)) return;
    reportRuntimeError(error, { kind: "react_render", componentStack: info?.componentStack });
    console.error("Akas gagal merender halaman", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main className="akas-runtime-error" role="alert">
        <section className="akas-runtime-error-card">
          <AkasLogo className="akas-runtime-error-mark" decorative />
          <p className="text-uppercase fw-bold text-primary small mb-2">Pemulihan aplikasi</p>
          <h1>Halaman belum berhasil dimuat.</h1>
          <p>Akas tetap aman. Muat ulang untuk mengambil versi aplikasi terbaru dari server.</p>
          <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
            Muat Ulang Aplikasi
          </button>
        </section>
      </main>
    );
  }
}

export default AppErrorBoundary;
